<template>
  <div id="app" :class="theme" v-cloak>
    <Header />
    <transition name="el-fade-in" mode="out-in">
      <router-view v-if="refreshActive" />
    </transition>
    <Footer v-if="$route.meta.showFooter" />
    <Sidebar v-if="access_token" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";
import Sidebar from "@/components/public/Sidebar";
import AddRouterFunc from "@/router/addRouter";

export default {
  name: "App",
  props: [],
  components: {
    Header,
    Footer,
    Sidebar
  },
  data() {
    return {
      // 点击当前连接刷新
      refreshActive: true
    };
  },
  computed: {
    ...mapGetters(["userToken", "userData", "theme", "accessToken", "access_token"])
  },
  created() {},
  mounted() {
    window.localStorage.setItem('v', '2023-8-7 10:29:56');
    const routerData = (JSON.parse(sessionStorage.getItem("userData")) || {}).routerData;
    if (routerData) {
      this.$nextTick(() => {
        this.addRouter();
      });
    }

    const themeName = localStorage.getItem("themeName");
    this.changeTheme(themeName ? themeName : "theme-w");
  },
  destroyed() {},
  methods: {
    ...mapActions(["setUserData", "logout", "setUserToken", "changeTheme"]),

    addRouter() {
      const routerData = AddRouterFunc.getNewRouerData(JSON.parse(sessionStorage.getItem("userData")).routerData);
      this.$router.addRoutes(routerData);
    },
    refresh() {
      this.refreshActive = false;
      this.$nextTick(() => {
        this.refreshActive = true;
      });
    }
  },
  watch: {
    access_token(val) {
    },
    "userData.routerData"(value) {
      // if(value.length){
      //   this.$nextTick(() => {
      //     this.addRouter();
      //   });
      // }
    }
  },
  filters: {}
};
</script>

<style scoped></style>
